/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pMenu.vue?vue&type=template&id=6702afac&scoped=true"
import script from "./pMenu.vue?vue&type=script&lang=js"
export * from "./pMenu.vue?vue&type=script&lang=js"
import style0 from "./pMenu.vue?vue&type=style&index=0&id=6702afac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6702afac",
  null
  
)

export default component.exports